import 'vuetify/styles'
import '@fortawesome/fontawesome-free/css/all.css'
import i18n from '@user-plugins/i18n'
import { useI18n } from 'vue-i18n'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, fa } from 'vuetify/iconsets/fa'
import { createVueI18nAdapter } from 'vuetify/locale/adapters/vue-i18n'

import defaults from './defaults.js'
import theme from './theme.js'

const vuetify = createVuetify({
    components,
    directives,
    defaults,
    theme: {
        ...theme,
        cspNonce: document.querySelector('meta[name="csp-nonce"]')?.content,
    },
    icons: {
        defaultSet: 'fa',
        aliases,
        sets: {
            fa,
        },
    },
    locale: {
        adapter: createVueI18nAdapter({ i18n: i18n, useI18n }),
    },
})

export default vuetify
